import React from "react";

import useFormWatch from "@rf-hooks/useFormWatch";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const useCountCatchMentTotal = () => {
  const { building = [] } = useFormWatch([CPropertyFormKeys.building]);

  const totalUnits = (Array.isArray(building) ? building : []).reduce(
    (acc, item) => acc + Number(item.unitsQuantity || 0),
    0
  );
  return {
    totalUnits
  };
};

export default useCountCatchMentTotal;
